import { render, staticRenderFns } from "./BlockPaymentSystem.vue?vue&type=template&id=ac6b14a8&scoped=true&"
import script from "./BlockPaymentSystem.vue?vue&type=script&lang=ts&"
export * from "./BlockPaymentSystem.vue?vue&type=script&lang=ts&"
import style0 from "./BlockPaymentSystem.vue?vue&type=style&index=0&id=ac6b14a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6b14a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSpacer})
